import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { CURRENT_AWARENESS_ARTICLE } from 'constants/requests'

export default new Controller({
  name: 'LegacyArticleRedirect',
  route: '(:aol/)article(/id/:id)',
  controller (Router, { params }) {
    const target = url(CURRENT_AWARENESS_ARTICLE, params)
    replaceUrl(target)
  }
})
